import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom'

import { hot } from 'react-hot-loader';
import { LicenseManager } from 'ag-grid-enterprise';
import { ToastContainer, toast } from 'react-toastify';
import Helmet from 'react-helmet';
import BodyClassName from 'react-body-classname';
import 'ag-grid-enterprise';

import 'bootswatch/paper/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'animate.css/animate.css';
import 'rc-slider/assets/index.css';
import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import  bootstrapStyles from './bootstrap.css';


import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS

import 'react-toastify/dist/ReactToastify.css';

import { connect } from 'react-redux';
import classNames from 'classnames';
import { Button, Modal } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { defer, reduce, startsWith, endsWith } from 'lodash';
import RequestChangePassword from './components/RequestChangePassword/RequestChangePassword';
import WindowResizeListener from '../../components/window-size-listener';
import SocketConnector from './SocketConnector';
import PusherReceiver from './PusherReceiver';
import HistoryLogModal from '../../components/history-logs/modal';
import DetectChromeExtenstion from './components/DetectChromeExtenstion';
import Loading from '../../components/loading';
import SyncToaster from '../../components/required-sync/toaster';

// Import Style
import styles from './App.css';

// Import Components
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import requiredSetupOrg from '../../components/required-setup-org';

// Import Actions
import {
  loginFromCookieRequest,
  logout,
} from '../Auth/AuthActions';
import { setCookie, getCookie, removeCookie } from '../../util/apiCaller';
import { getUser, getUserCurrentOrganization } from '../Auth/AuthReducer';
import { getUserPreferences, getFontSize } from './AppReducer';

import { changeWindowDimensions, changeHeaderHeight, changeFooterHeight,
  fetchTablePreferences, changeContainerWidth,
  fetchUserPreference, updatePreference, fetchOrganizationSAMLUrl } from './AppActions';
import AppRoute from './routes';
import LoginRoute from './login-routes';

const REDIRECT_COOKIE = 'redirect';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      showConfirm: false,
      loadingPreference: true,
      checkedCookie: false,
      redirectUrl: null,
    };
    this.logout = this.logout.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
    if (process.env.REACT_APP_AG_GRID_KEY) {
      LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_KEY);
    }
    if (typeof window !== 'undefined') {
      window.document.documentElement.style.display = ''; // FOUC
    }
  }

  getChildContext() {
    const { location, history, match } = this.props;

    return {
      addNotification: (content, config = {}) => {
        return toast(content, { type: toast.TYPE.INFO, ...config });
      },
      updateUserPreference: (name, value) => {
        return this.props.dispatch(updatePreference(name, value));
      },
      getUserPreference: (name, defaultValue) => {
        if (this.props.userPreferences[name] !== null && this.props.userPreferences[name] !== undefined) {
          return this.props.userPreferences[name];
        }
        return defaultValue;
      },
      userPreferences: this.props.userPreferences,
      userCurrentOrganization: this.props.userCurrentOrganization,
      router: {
        location,
        history,
        match,
      },
    };
  }

  componentDidMount() {
    this.setState({ isMounted: true }); // eslint-disable-line
    this.props.dispatch(loginFromCookieRequest())
      .then(
        () => {
          this.setState({ checkedCookie: true });
        },
        () => {
          this.setState({ checkedCookie: true });
        },
      );
    const { user } = this.props;
    if (user._id) {
      this.loadPreferences();
    }
  }

  getIsLoginPage() {
    const { location: { pathname } } = this.props;
    return (startsWith(pathname, '/signin') || pathname === '/reset');
  }

  isUnsubscribePage() {
    const { location: { pathname } } = this.props;
    return (startsWith(pathname, '/unsubscribe'));
  }

  redirectToLoginPage(url = null) {
    const loginUrl = url || '/signin';
    if (!this.getIsLoginPage()) {
      if (startsWith(loginUrl, '/')) {
        if (this.context.router) {
          // this.context.router.history.push({ pathname: loginUrl });
          this.setState({ redirectUrl: loginUrl });
        } else {
          window.location.href = loginUrl;
        }
      } else {
        window.location.href = loginUrl;
      }
    }
  }

  checkRedirect(nextProps) {
    const nextUser = nextProps.user;
    const currentUser = this.props.user;
    if (currentUser && nextUser && currentUser._id === nextUser._id && nextUser._id) {
      const isLoginPage = this.getIsLoginPage();
      if (isLoginPage) {
        const redirectUrl = getCookie(REDIRECT_COOKIE);
        removeCookie(REDIRECT_COOKIE);
        if (redirectUrl !== undefined) {
          this.setState({ redirectUrl });
        } else if (endsWith(window.location.href.toString(), '/signin')) {
          this.setState({ redirectUrl: '/' }, () => {
            this.setState({ redirectUrl: null });
          });
        }
      } else {
        const redirectUrl = getCookie(REDIRECT_COOKIE);
        removeCookie(REDIRECT_COOKIE);
        if (redirectUrl) {
          this.setState({ redirectUrl });
        }
      }
    } else if (currentUser && !nextUser) {
      // from login to logout
      // clean local storage
      removeCookie(REDIRECT_COOKIE);
      this.redirectToLoginPage();
    } else if (!currentUser && nextUser) {
      // from logout to login
      // TODO: check if we need to redirect, do redirect, then erase locall storage
      const isLoginPage = this.getIsLoginPage();
      if (isLoginPage) {
        // do redirect
        const redirectUrl = getCookie(REDIRECT_COOKIE) || '/';
        removeCookie(REDIRECT_COOKIE);
        this.setState({ redirectUrl });
      }
    } else if (!nextUser || !nextUser._id) {
      const nextPathname = nextProps.location.pathname;
      const isLoginPage = this.getIsLoginPage() || this.isUnsubscribePage();  // logout user can visit unsubscribe page.
      if (!isLoginPage) {
        // redirect to login page
        setCookie(`${nextPathname}${nextProps.location.search}`, REDIRECT_COOKIE); // search query?
        const isFeedbackPage = startsWith(nextPathname, '/request-feedback');
        if (isFeedbackPage) {
          const params = nextPathname.split('/'); // ["", "request-feedback", "force", "organizations", "00D300000006XCGEA2",...]
          const orgType = params[2];
          const orgId = params[4];
          if (orgType && orgId) {
            let id = orgId;
            if (orgType === 'hubspot') {
              id = `hs-${id}`;
            } else if (orgType === 'azure') {
              id = `az-${id}`;
            }
            this.props.dispatch(fetchOrganizationSAMLUrl(id))
              .then(
                ({ url }) => {
                  this.redirectToLoginPage(url);
                },
                () => {
                  this.redirectToLoginPage();
                },
              );
          } else {
            this.redirectToLoginPage();
          }
        } else {
          this.redirectToLoginPage();
        }
      }
    }
  }


  componentWillReceiveProps(nextProps) {
    const nextUser = nextProps.user;
    const currentUser = this.props.user;
    const nextOrg = nextUser.pretent_organization || nextUser.organization || {};
    const currentOrg = currentUser.pretent_organization || currentUser.organization || {};

    const currentPathname = this.props.location.pathname;
    const nextPathname = nextProps.location.pathname;
    if (this.getIsLoginPage() && nextPathname !== currentPathname) {
      this.checkHeaderFooterSize();
    }
    let shouldLoad = false;
    if (nextUser._id !== currentUser._id) {
      if (nextUser._id) {
        shouldLoad = true;
      }
    }
    if (!nextUser || !nextUser.$token) {
      if (this.socket) {
        this.socket.emit('leave-organization');
        this.socket.emit('leave-admin');
      }
    }
    if (nextUser._id) {
      if (nextOrg._id !== currentOrg._id) {
        shouldLoad = true;
      }
    }
    if (shouldLoad) {
      this.loadPreferences();
    }
    this.checkRedirect(nextProps)
  }


  logout() { // eslint-disable-line react/sort-comp
    this.props.dispatch(logout())
      .then(() => {
        this.setState({ showConfirm: false });
        defer(this.context.router.history.push, '/logout');
      });
  }

  loadPreferences() {
    this.setState({ loadingPreference: true });
    Promise.all([
      this.props.dispatch(fetchUserPreference()),
      this.props.dispatch(fetchTablePreferences()),
    ])
      .then(
        () => {
          this.setState({ loadingPreference: false });
        },
        () => {
          this.addNotification(
            (
              <div>Cannot load user preferences</div>
            ), { type: toast.TYPE.ERROR },
          );
        },
      );
  }

  closeConfirmModal() {
    this.setState({ showConfirm: false });
  }

  checkHeaderFooterSize() {
    if (typeof document !== 'undefined' && document.body) {
      const headers = document.body.querySelectorAll('#app-header > .navbar');
      const headerHeight = reduce(headers, (h, header) => h + header.offsetHeight, 0);
      this.props.dispatch(changeHeaderHeight(headerHeight));
      const footer = document.body.querySelector('#app-footer .container');
      if (footer) {
        this.props.dispatch(changeFooterHeight(footer.offsetHeight));
      }
    }
  }

  onWindowResize(windowSize) {
    this.props.dispatch(changeWindowDimensions(windowSize.windowWidth, windowSize.windowHeight));
    if (this.container) {
      this.props.dispatch(changeContainerWidth(this.container.offsetWidth));
    }
    this.checkHeaderFooterSize();
  }

  addNotification(content, config = {}) {
    toast(content, { type: toast.TYPE.INFO, ...config });
  }

  renderConfirmModal() {
    return (
      <Modal className={styles.logoutModal} bsSize="small" show={this.state.showConfirm} onHide={this.closeConfirmModal}>
        <Modal.Header closeButton>
          <Modal.Title><Fa name="power-off" /> Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>Are you sure you want to end this session?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-xs-6 text-left">
              <Button onClick={this.closeConfirmModal}>Cancel</Button>
            </div>
            <div className="col-xs-6">
              <Button onClick={this.logout} bsStyle="warning">YES - Logout</Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  renderSyncNotification() {
    return (
      <ToastContainer autoClose={3000} position="bottom-left" />
    );
  }

  render() {
    const { user, location, fontSize, userCurrentOrganization } = this.props;
    const {
      isMounted, loadingPreference, checkedCookie, redirectUrl,
    } = this.state;
    if (!checkedCookie) {
      return (<Loading />);
    }

    const { pathname } = location;

    const currentlyLoginPage = this.getIsLoginPage();
    const isLogin = user && user._id !== null && user._id !== undefined;
    // to prevent FOUC
    const cls = classNames([
      isLogin ? styles.container : null,
      isMounted ? styles.containerLoaded : null,
    ]);
    return (
      <SocketConnector key={userCurrentOrganization ? userCurrentOrganization._id : null}>
        <PusherReceiver />
        <BodyClassName className={startsWith(pathname, '/apex') ? 'hide-branding' : ''} />
        {this.renderConfirmModal()}
        {this.renderSyncNotification()}
        <WindowResizeListener onResize={this.onWindowResize} />
        <RequestChangePassword location={this.props.location} />
        <Helmet
          title="TruVoice Automation"
          titleTemplate="%s - TruVoice Automation"
          bodyAttributes={{
            'font-size': fontSize,
          }}
          meta={[
            { charset: 'utf-8' },
            { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' },
          ]}
        />
        {isLogin && <Header />}
        <div className={cls}>
          {isLogin &&
            <div>
              {!currentlyLoginPage &&
                <div>
                  {loadingPreference && <div />}
                  {!loadingPreference && <AppRoute />}
                </div>
              }
            </div>
          }
          {redirectUrl !== null && <Redirect to={redirectUrl} />}
          {!isLogin && <LoginRoute />}
        </div>
        <div
          ref={(el) => { this.container = el; }}
          className="container"
          style={{ fontSize: '1px', lineHeight: '1px' }}
        />
        {isLogin && <Footer />}
        {isLogin && <HistoryLogModal />}
        {isLogin && <DetectChromeExtenstion />}
        {isLogin && <SyncToaster />}
      </SocketConnector>
    );
  }
}

App.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.shape({
    _id: PropTypes.string,
    user_id: PropTypes.string,
    $token: PropTypes.string,
    pretent_organization: PropTypes.shape({}),
    organization: PropTypes.shape({}),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string, // `?query1=one`
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired,
  userCurrentOrganization: PropTypes.shape({
    _id: PropTypes.string,
  }),
  userPreferences: PropTypes.shape({}).isRequired,
  fontSize: PropTypes.number.isRequired,
};
App.defaultProps = {
  userCurrentOrganization: null,
};

App.contextTypes = {
  router: PropTypes.shape({}),
};
App.childContextTypes = {
  addNotification: PropTypes.func.isRequired,
  updateUserPreference: PropTypes.func.isRequired,
  getUserPreference: PropTypes.func.isRequired,
  userPreferences: PropTypes.shape({}).isRequired,
  userCurrentOrganization: PropTypes.shape({}).isRequired,
  router: PropTypes.shape({}),
};

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
    fontSize: getFontSize(state),
    userCurrentOrganization: getUserCurrentOrganization(state),
    userPreferences: getUserPreferences(state),
  };
}


export default hot(module)(withRouter(connect(mapStateToProps)(requiredSetupOrg(App))));
